<template>
  <article>
    <section class="padT10">
      <div class="select-list-img process-audit">
        <ul>
          <li>
            <a href="javascript:void(0);">
              <div class="select-img"><img src="../../stylesheets/images/car1.png" alt="" class="imgauto"></div>
              <div class="select-detail">
                <div>
                  <p class="p1">{{trajectory.plate_number}}<em class="opacity4">－{{trajectory.model_desc}}</em></p>
                  <p class="p2">车架号：{{trajectory.vin}}</p>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <h2 class="title-bar">轨迹记录</h2>
      <div class="process-audit-list">
        <ul>
          <!-- <step-item v-for="(item, index) in history" :image-list.sync="imageList" :item=item inline-template :key="index" :length="history.length"> -->
            <li v-for="(item, index) in history"  :key="index">
              <div class="status-icon" v-if="history.length > 1" >
                <div class="line-blue"></div>
              </div>
              <div class="status-icon" style="height:0px;" v-else>
                <div class="line-blue"></div>
              </div>
              <div class="status-mes">
                <p>
                  <span class="show-time">{{ item.occurred_at }}</span>
                  <span class="description">{{ item.description }}</span>
                  <span class="description">车辆类型：{{ item.car_incoming_type || '--'}}</span>
                  <span v-if="item.exit_category_info" class="description">放行备注：{{ item.exit_category_info }}</span>
                  <span v-if="item.reject_reason">驳回原因: {{item.reject_reason}}</span>
                  <template v-if="item.image_urls.length">
                    <a
                      class="previewer-img"
                      v-for="(img, index) in item.image_urls"
                      :key="img"
                      @click="goPic(img, item.image_urls)"
                    >
                      <img src="../../stylesheets/images/unpic.png" />
                      <span class="previewer-img__text">查看图片{{item.image_urls.length > 1 ? index + 1 : ''}}</span>
                    </a>
                  </template>
                </p>
                <i class="original"></i>
              </div>
            </li>
          <!-- </step-item> -->
        </ul>
      </div>
      <images-previewer :list="imageList" ref="previewer" :options="options" :w='600' :h='400'></images-previewer>
    </section>
  </article>
</template>
<script>
import util from '../../common/util'
// import { Previewer } from '@lx-frontend/cvux'
import ImagesPreviewer from '@lx-frontend/images-previewer'

export default {
  data() {
    return {
      trajectory: {},
      id: 0,
      imageList: [],
      options: {
        getThumbBoundsFn (index) {
          let isServer = typeof window === 'undefined'
          if (isServer) return
          let thumbnail = document.querySelectorAll('.previewer-img')[index]
          let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
          let rect = thumbnail.getBoundingClientRect()
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
        }
      }
    }
  },
  created() {
    let id = this.id = this.$route.params.id
    this.$rest.barriergate.getTrajectoryDetail(null, id + '/exiting/process/history').then((res) => {
      if (res.code === 0) {
        this.trajectory = res.data
      } else {
        this.showToast(res.message)
      }
    })
  },
  methods: {
    goPic(current, urls) { // 查看图片
      this.$wechat.wx.previewImage({
        current,
        urls
      })
    },
    render(arr = []) {
      const v = arr[0]
      let img = new window.Image()
      img.src = v.src
      const loadpromise = new Promise((resolve) => {
        // 存在缓存
        if (img.complete) {
          v.w = img.width
          v.h = img.height
          resolve()
        }
        // 完全加载完毕的事件
        img.onload = () => {
          v.w = img.width
          v.h = img.height
          resolve()
        }
      })
      loadpromise.then(() => this.$refs.previewer.show(0))
      // 如果图片被缓存，则直接返回缓存数据
    }
  },
  components: {
    ImagesPreviewer
    // Previewer
    // 'step-item': {
    //   props: {
    //     item: Object,
    //     length: Number,
    //     imageList: Array
    //   }
    // }
  },
  computed: {
    history (date) {
      return this.trajectory.history ? this.trajectory.history.map((item) => {
        return {
          ...item,
          occurred_at: item.occurred_at ? util.formatTime(item.occurred_at, 'yyyy-MM-dd hh:mm:ss') : ''
        }
      }) : []
    }
  }
}
</script>
<style lang="less">
  @import "../../stylesheets/modules/barriergate/trajectoryDetail.less";
</style>
